module.exports = __webpack_public_path__ + "img/logo-klaus-rebrand.03da3d94.svg";